import { KLAGE_ILEGGELSE_LIGHTBOX_IMAGE } from "../actions/klager/klageAction";
import { CreateNewReducer } from "../utils/reducerUtils";

const INITIAL_STATE = [];

const klageIleggelseLightboxImageReducer = (
  state = INITIAL_STATE,
  action
) => CreateNewReducer(state, action, KLAGE_ILEGGELSE_LIGHTBOX_IMAGE);

export default klageIleggelseLightboxImageReducer;
